import React, { ReactNode } from 'react';

import { translate } from '@portal/services/i18n';

import FileEdit from '~/assets/svg/loan-icons/ic_file_edit.svg?react';
import Upload from '~/assets/svg/loan-icons/ic_upload.svg?react';

export interface LoanWarrantyProps {
  hasWarranty: boolean;
  warranties: FileList | null;
  setWarranties: (file: FileList | null) => void;
}

const LoanWarranty = ({
  setWarranties,
  warranties,
  hasWarranty,
}: LoanWarrantyProps) => {
  const getFiles = (): ReactNode => {
    const names: string[] = [];
    if (!warranties) {
      return;
    }
    for (let i = 0; i < warranties.length; i += 1) {
      if (warranties.item(i)) {
        names.push((warranties.item(i) as File).name);
      }
    }
    return (
      <div className="loan-warranty__input__list__files">
        {names.map((name) => (
          <p key={name} className="loan-warranty__input__list__files__name">
            {name}
          </p>
        ))}
      </div>
    );
  };

  return (
    <div className="loan-warranty">
      {hasWarranty ? (
        <>
          <h1 className="loan-warranty__title">
            {translate('PAGES.LOAN.SIMULATE.WARRANTY.TITLE')}
          </h1>
          <h2 className="loan-warranty__subtitle">
            {translate('PAGES.LOAN.SIMULATE.WARRANTY.SUBTITLE')}
          </h2>
          <div className="loan-warranty__input">
            {warranties && warranties.length > 0 ? (
              <div className="loan-warranty__input__list">
                {getFiles()}
                <label
                  className="loan-warranty__input__list__label"
                  htmlFor="file-upload-warranty"
                >
                  <FileEdit />
                </label>
              </div>
            ) : (
              <>
                <label htmlFor="file-upload-warranty">
                  <p>{translate('PAGES.LOAN.SIMULATE.WARRANTY.PLACEHOLDER')}</p>
                  <span>
                    <Upload />
                  </span>
                </label>

                <div className="loan-warranty__input__title">
                  <p>
                    {translate(
                      'PAGES.AUTH.REGISTER.ONBOARD.PF.DOCUMENT.FORM.UPLOAD_MAX'
                    )}
                  </p>
                </div>
              </>
            )}
            <input
              className="loan-warranty__input__input"
              type="file"
              name="file-upload-warranty"
              id="file-upload-warranty"
              title="input"
              accept=".pdf"
              multiple
              onChange={(event) => setWarranties(event.target.files ?? null)}
            />
          </div>
        </>
      ) : (
        <>
          <h1 className="loan-warranty__title">
            {translate('PAGES.LOAN.SIMULATE.WARRANTY.TITLE')}
          </h1>
          <h2 className="loan-warranty__subtitle">{`${translate(
            'PAGES.LOAN.SIMULATE.NO_WARRANTY.SUBTITLE'
          )}.`}</h2>
        </>
      )}
    </div>
  );
};

export default LoanWarranty;
